<template  minapp='mpx' xlang='wxml'>
  <view
    class="swiper-container"
    wx:if="{{ homeOrderList && homeOrderList.length > 0 && showOrders }}"
  >
    <swiper
      display-multiple-items="1"
      bindchange="onChange"
      indicator-dots="{{false}}"
      indicator-color="#FFFFFF"
      current="{{current}}"
      autoplay="{{true}}"
      interval="{{100000000000000000}}"
      circular="{{false}}"
      class="swiper"
      previous-margin="10px"
      next-margin="10px"
      easing-function="linear"
      observer="{{true}}"
      observeParents="{{true}}"
      ref="swiper"
      scroll-options="{{
        {
          eventPassthrough: 'vertical'
        }
      }}"
    >
      <view wx:for="{{homeOrderList}}" wx:for-item="item" wx:key="index">
        <swiper-item class="swiper-item">
          <view
            class="{{homeOrderList.length === 1 ? 'train-info-content-single' : 'train-info-content' }}"
            wx:style="{{(homeOrderList.length > 1&&(index===homeOrderList.length-1)) ? 'padding-right: 0px' : ''}}"
          >
            <schedule-item
              homeOrderItem="{{item}}"
              isSingleOrder="{{isSingleOrder}}"
              bind:refresh="refresh"
            />
          </view>
        </swiper-item>
      </view>
    </swiper>
    <view class="process" wx:if="{{homeOrderList.length > 1}}">
      <view
        class="process-item"
        wx:for="{{homeOrderList.length}}"
        wx:class="{{{'process-active': index === current}}}"
      ></view>
    </view>
  </view>
  <view
    style="height: 184px"
    wx:if="{{ homeOrderList && !showOrders && homeOrderList.length>0 && showBox }}"
  ></view>
</template>

<script>
  import { createComponent, mpx } from '@didi/es-mpx-creator'
  import { requestHomeOrderListApi } from '@/api/home'
  import { getStorage } from '@/utils/storage'
  import { trackEvent } from '@/common/track'
  import onShowHandleMixins from '@/mixins/homeTabOnShowHandleMixins'

  createComponent({
    mixins: [onShowHandleMixins],
    data() {
      return {
        isSingleOrder: false,
        current: 0,
        homeOrderList: [],
        showOrders: false,
        showBox: false
      }
    },
    pageLifetimes: {
      hide: function () {
        this.timer && clearTimeout(this.timer)
        this.showOrders = false
      }
    },
    computed: {
      homeOrderItem() {
        return this.homeOrderList[this.current]
      }
    },
    methods: {
      onShowHandle() {
        this.getHomeOrder()
      },
      refresh() {
        this.showOrders = this.homeOrderList.length === 1 ? false : true
        this.getHomeOrder()
      },
      async getHomeOrder() {
        const userInfo = getStorage('userInfo')
        const { data, success } = await requestHomeOrderListApi({
          uid: +userInfo.uid
        })
        if (success && data?.list?.length) {
          this.homeOrderList = data.list || data
          this.showOrders = false
          this.showBox = true
          setTimeout(() => {
            this.showOrders = true
          }, 1)
          this.trackSw(
            this.homeOrderList[0]?.approaching_departure_desc || this.homeOrderList[0]?.status_name
          )
          this.$forceUpdate()
        } else {
          this.showOrders = false
          this.showBox = false
        }
        this.isSingleOrder = this.homeOrderList.length === 1
        // 轮询接口，查看状态变化
        this.timer && clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          this.getHomeOrder()
        }, 60 * 1000)
      },
      onChange(event) {
        this.current = event.detail.current
      },
      trackSw(type) {
        trackEvent('userteam_train_home_ordercard_sw', 'UT-火车票-首页-订单卡片-展现', {
          type
        })
      }
    },
    watch: {
      current: {
        handler(val) {
          this.trackSw(
            this.homeOrderList[this.current]?.approaching_departure_desc ||
              this.homeOrderList[this.current]?.status_name
          )
        },
        immediate: true
      }
    }
  })
</script>

<style lang='stylus' scoped>
  @import '~@/mixins/stylus/color.styl'

  .swiper-container
    overflow visible
    margin-top 8px
  .swiper
    width 100%
    // height 113px
    // background-color #FFFFFF
    overflow visible
  .swiper-inline-didi-padding
    margin-top -18px
    padding 0px 0px 0px 0px
    margin-bottom -12px
  .swiper-inline-didi-padding-reason
    margin-top -10px
    padding 0px 0px 0px 0px
    margin-bottom -4px
  .swiper-didi-padding
    padding 0px 0px
  .swiper-item
    // height 105px
    display flex
    justify-content center
    align-items center
  .train-info-content
    display flex
    flex-direction column
    width 99%
    // background-color #ffffff
    border-radius 8px
    box-sizing border-box
    padding-right 5px
  .train-info-content-single
    display flex
    flex-direction column
    width 93vw
    // background-color #ffffff
    border-radius 8px
    box-sizing border-box
  .unselected-item
    transform scale(0.75, 1)
  .train-info-item
    padding 13px 15px 16px 15px
  .train-info-item-top
    padding 3px 15px 16px 15px
  .process
    margin-top 6px
    display flex
    align-items center
    justify-content center
    &-item
      width 4px
      height 2px
      background #FFFFFF
      border-radius 50px
      &:not(:first-child)
        margin-left 2px
    &-active
      width 8px
      height 2px
      background #222222
      border-radius 50px
</style>

<script name='json'>
  module.exports = {
    component: true,
    usingComponents: {
      'schedule-item': './schedule-item'
    }
  }
</script>